import React from "react";
import Checker from "./checker";
import { autobind } from "lib/decorators";

export default class PasswordManager extends Checker {
  constructor(props, context) {
    super(props, context);
  }

  @autobind
  async updatePassword() {
    let errors = {};
    let saveError = "-";
    let nextVal = this.next.value;

    this.checkPolicy(nextVal, errors);

    if (!this.next.value)
      this.addError(errors, "error_next", this.l("enterPassWord"));

    if (!this.repeat.value)
      this.addError(errors, "error_repeat", this.l("lblVerifyPassword"));

    if (nextVal != this.repeat.value)
      this.addError(errors, "error_repeat", this.l("passwordsDontMatch"));

    let hf = this.props["hf-element"];
    if (hf)
      document.getElementById(hf).value =
        Object.keys(errors).length <= 0 ? nextVal : "";

    this.setState({ errors, didSave: saveError === "" });
  }

  doRender() {
    let { ready, errors, didSave } = this.state || {};

    if (!ready) return <div />;

    let { error_next = [], error_repeat = [] } = errors || {};

    return (
      <div className="passwordmanager">
        {didSave && (
          <div id="cPlhMain_DivInfoPwd" className="info-message tag tag-info">
            {this.l("infosaved")}
          </div>
        )}
        <div className="flex align-c relative">
          <div className="passwordmanager-column">
            <span>{this.l("password")}:</span>
          </div>
          <br />
          <input
            type="password"
            ref={(input) => (this.next = input)}
            onChange={this.updatePassword}
          />
          <br />
        </div>
        <div style={{ marginTop: "3px" }}>
          {error_next.map((e) => (
            <div className="passwordmanager-error helpBox animated fadeInDown">
              <span>
                {e}
                <br />
              </span>
            </div>
          ))}
        </div>
        <div className="flex align-c relative">
          <div className="passwordmanager-column" style={{ maxWidth: "111px" }}>
            <span>{this.l("lblVerifyPassword")}:</span>
          </div>
          <br />
          <input
            type="password"
            ref={(input) => (this.repeat = input)}
            onChange={this.updatePassword}
          />
          <br />
        </div>
        <div>
          {error_repeat.map((e) => (
            <div className="passwordmanager-error helpBox animated fadeInDown">
              <span>
                {e}
                <br />
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
